var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.id_competition !== undefined)?_c('CompetitionDetail',{key:_vm.id_competition,attrs:{"tab":_vm.tabToOpen,"idCompetition":_vm.id_competition},on:{"is-components-ready":_vm.isComponentsReady}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }